import { parseDate } from '@mirai/locale';

import { CALENDAR_FORMAT } from './constants';

export const parseValue = ([from, to] = []) => [
  from ? parseDate(from, CALENDAR_FORMAT) : undefined,
  to ? parseDate(to, CALENDAR_FORMAT) : undefined,
];
